import React from "react";
import { Container, Card, CardContent, Typography, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"; // Ensure @mui/icons-material is installed

interface LoginProps {
  login: () => void;
}

const CustomLogin: React.FC<LoginProps> = ({ login }) => {
  return (
    <Container
      maxWidth="sm"
      sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}
    >
      <Card sx={{ textAlign: "center", padding: 3, boxShadow: 3, maxWidth: 400 }}>
        <CardContent>
          <LockOutlinedIcon sx={{ fontSize: 50, color: "primary.main", mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Sign in with Okta
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Please log in to access your account.
          </Typography>
          <Button variant="outlined" onClick={login}>Login</Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default CustomLogin;
